import client from 'src/services/client';
import { TOrder } from 'src/types/orders';

const orderRequest = {
  fetchOrder: async (id: TOrder['id']): Promise<TOrder> => {
    return await client.get(`/v3/orders/${id}`);
  },
};

export default orderRequest;
